import React from 'react';
import { Box, Typography } from '@mui/material';
import CampaignIcon from '@mui/icons-material/Campaign';
import Notifier from '../../Models/Interfaces/Notifier';

interface Props {
  selectedNotifier: Notifier;
}

const NotifierComponent: React.FC<Props> = ({ selectedNotifier }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        backgroundColor: 'primary.light',
        padding: 2,
        borderRadius: 1.5,
        marginY: '15px',
        border: 1, borderColor: 'divider'
      }}
    >
      <CampaignIcon sx={{ marginRight: '10px', color: 'primary.main' }} />
      <Typography variant="body2" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
        Tilkynnandi: {selectedNotifier.notifierName} ({selectedNotifier.notifierId})
      </Typography>
    </Box>
  );
};

export default NotifierComponent;
